import { Link } from "react-router-dom";
import { topicCategories } from "@/mocks/topics";

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-secondary-900 text-background-100">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 gap-8 px-4 py-12 sm:grid-cols-2 md:px-8 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-fire-fill h-5 w-5 flex items-center justify-center"></i>
            </span>
            <span className="font-heading text-lg font-black text-background-50">黑料瓜网</span>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-background-200/80">
            把分散在各处的娱乐热议整理成榜单和速递，帮你在碎片时间里快速吃瓜不迷路。内容以公开讨论话题为主，人物事件均作虚构化处理。
          </p>
        </div>

        <div>
          <h4 className="font-label text-sm font-bold text-accent-300">
            <span className="whitespace-nowrap">站内导航</span>
          </h4>
          <ul className="mt-3 flex flex-col gap-2 text-sm">
            <li>
              <Link to="/" className="text-background-200/85 transition-colors hover:text-background-50">
                首页速递
              </Link>
            </li>
            <li>
              <Link to="/rank" className="text-background-200/85 transition-colors hover:text-background-50">
                吃瓜榜单
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-background-200/85 transition-colors hover:text-background-50">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/about#principle" className="text-background-200/85 transition-colors hover:text-background-50">
                内容原则
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-label text-sm font-bold text-accent-300">
            <span className="whitespace-nowrap">主题分类</span>
          </h4>
          <ul className="mt-3 flex flex-col gap-2 text-sm">
            {topicCategories.map((cat) => (
              <li key={cat.slug}>
                <Link
                  to={`/category/${cat.slug}`}
                  className="text-background-200/85 transition-colors hover:text-background-50"
                >
                  {cat.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-label text-sm font-bold text-accent-300">
            <span className="whitespace-nowrap">联系与投稿</span>
          </h4>
          <ul className="mt-3 flex flex-col gap-3 text-sm">
            <li className="flex items-center gap-2 text-background-200/85">
              <i className="ri-mail-line h-4 w-4 flex items-center justify-center text-accent-400"></i>
              heiliaogua@example.com
            </li>
            <li className="flex items-center gap-2 text-background-200/85">
              <i className="ri-time-line h-4 w-4 flex items-center justify-center text-accent-400"></i>
              榜单每 2 小时刷新一次
            </li>
            <li>
              <Link
                to="/about#contact"
                className="inline-flex items-center gap-1 rounded-md bg-accent-500 px-3 py-2 font-label text-sm font-medium text-secondary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-megaphone-line h-4 w-4 flex items-center justify-center"></i>
                我要爆料
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-2 px-4 py-5 text-xs text-background-200/70 sm:flex-row sm:items-center sm:justify-between md:px-8">
          <p>© 2026 黑料瓜网 · 娱乐热点资讯聚合平台</p>
          <p>本站内容涉及人物与事件均为虚构，仅供娱乐话题讨论参考</p>
        </div>
      </div>
    </footer>
  );
}